<div class="flex flex-row p-4 pr-6 border-b border-gray-1">
  <div class="h-8 flex flex-1 flex-wrap content-center uppercase text-xs font-bold">
    {{ title() }}
  </div>
  <button
    id="options-panel-multi_close"
    class="text-gray-8"
    modus-icon-button
    [modus-tooltip]="translations.close.tooltip.text"
    [disabled]="disabled()"
    (click)="removeAllClicked.emit()"
  >
    <md-icon>close</md-icon>
  </button>
</div>

<div class="flex-1 overflow-y-auto p-4 text-sm">
  <div class="flex flex-col mb-4 -ml-2 leading-8 items-start gap-2">
    <button
      id="options-panel-multi_view_in_3d"
      modus-button
      [modus-tooltip]="translations.viewIn3d.tooltip.text"
      [disabled]="disabled()"
      (click)="viewIn3dClicked.emit()"
    >
      <md-icon class="mr-1">cube</md-icon>
      {{ translations.viewIn3d.button.text }}
    </button>
    @if (enableViewInNumark()) {
      <button
        id="options-panel-multi_view_in_numark"
        modus-button
        [disabled]="disabled()"
        (click)="viewInNumark()"
      >
        <md-icon class="mr-1">template</md-icon>
        {{ translations.viewInNumark.text }}
      </button>
    }

    @if (!readonly()) {
      <button
        id="options-panel-multi_edit_tags"
        modus-button
        [modus-tooltip]="translations.editTags.tooltip.text"
        [disabled]="disabled()"
        (click)="editTagsClicked.emit()"
      >
        <md-icon class="mr-1">ticket</md-icon>
        {{ translations.editTags.button.text }}
      </button>
    }

    <button
      id="options-panel-multi_download"
      modus-button
      [modus-tooltip]="translations.download.tooltip.text"
      [disabled]="disabled()"
      (click)="downloadClicked.emit()"
    >
      <md-icon class="mr-1">download</md-icon>
      {{ translations.download.button.text }}
    </button>

    @if (!readonly() && allowDelete()) {
      <button
        id="options-panel-multi_delete"
        modus-button
        [modus-tooltip]="translations.delete.tooltip.text"
        [disabled]="disabled()"
        (click)="deleteClicked.emit()"
      >
        <md-icon class="mr-1">delete</md-icon>
        {{ translations.delete.button.text }}
      </button>
    }
  </div>

  <div class="flex flex-col">
    <div class="-ml-4 -mr-4 mt-1 mb-2 border-b border-gray-1"></div>
    <div class="font-medium mt-2 mb-4">{{ translations.selected.text }}</div>
    @for (model of scandataModels(); track model.id) {
      <div class="flex flex-row mb-4">
        <md-icon class="text-gray-8">file</md-icon>
        <div
          class="w-full overflow-hidden text-ellipsis whitespace-nowrap leading-8 ml-2"
          [modus-tooltip]="model.name"
        >
          {{ model.name }}
        </div>
        <button
          id="options-panel-multi_remove"
          class="text-gray-8"
          modus-icon-button
          [modus-tooltip]="translations.remove.tooltip.text"
          [disabled]="disabled()"
          (click)="removeModelClicked.emit(model)"
        >
          <md-icon>close</md-icon>
        </button>
      </div>
    }
  </div>
</div>
